module.exports = __webpack_public_path__ + "static/media/center_01.aa4e6c2d.jpg";